import { FC, useEffect, useState } from 'react';
// Components
import { Button } from 'components/Buttons';
// Icons
import { IoIosSkipForward } from 'react-icons/io';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  onSkip: () => void;
}

const SkipButton:FC<Props> = ({
  // Props
  onSkip
}) => {
  const { t } = useTranslation();
  const [ skipCountdown, setSkipCountdown ] = useState<number>(3);

  useEffect(() => {
    const interval = setInterval(() => {
      setSkipCountdown(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="absolute right-0 bottom-0 m-4 z-10">
      <Button
        onClick={onSkip}
        disableShadow
        size="small"
        disabled={skipCountdown > 0}
        className="primary-button flex items-center gap-1"
      >
        {skipCountdown > 0 ? `${skipCountdown} ${t('buttons.skip')}` : t('buttons.skip')}
        <IoIosSkipForward />
      </Button>
    </div>
  )
}

export default SkipButton;
